var $d539c4192bcea66e$exports = {};
$d539c4192bcea66e$exports = {
    "info": `\u{645}\u{639}\u{644}\u{648}\u{645}\u{627}\u{62A}`,
    "negative": `\u{62E}\u{637}\u{623}`,
    "positive": `\u{62A}\u{645} \u{628}\u{646}\u{62C}\u{627}\u{62D}`
};


export {$d539c4192bcea66e$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
